import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Logo } from "@/components/Logo";
import { Mail, MapPin } from "lucide-react";

export const Footer = () => {
  const { t } = useTranslation();
  return (
    <footer className="bg-[#071225] text-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-1">
            <Logo variant="light" size="lg" />
            <p className="mt-4 text-sm text-white/70 leading-relaxed">{t("footer.tagline")}</p>
            <p className="mt-2 text-xs text-white/50">{t("footer.description")}</p>
          </div>
          <div>
            <h4 className="text-sm font-semibold mb-3">{t("footer.service")}</h4>
            <ul className="space-y-2 text-sm text-white/70">
              <li><Link to="/perche-cxoora" className="hover:text-white">{t("nav.why_cxoora")}</Link></li>
              <li><Link to="/soluzioni" className="hover:text-white">{t("nav.solutions")}</Link></li>
              <li><Link to="/come-funziona" className="hover:text-white">{t("nav.how_it_works")}</Link></li>
              <li><Link to="/per-le-imprese" className="hover:text-white">{t("nav.for_companies")}</Link></li>
              <li><Link to="/per-i-manager" className="hover:text-white">{t("nav.for_managers")}</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-sm font-semibold mb-3">{t("footer.resources")}</h4>
            <ul className="space-y-2 text-sm text-white/70">
              <li><Link to="/faq" className="hover:text-white">{t("nav.faq")}</Link></li>
              <li><Link to="/checkup" className="hover:text-white">{t("nav.free_checkup")}</Link></li>
              <li><Link to="/login" className="hover:text-white">{t("common.login")}</Link></li>
              <li><Link to="/register" className="hover:text-white">{t("common.register")}</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-sm font-semibold mb-3">{t("footer.legal")}</h4>
            <ul className="space-y-2 text-sm text-white/70">
              <li><Link to="/privacy" className="hover:text-white">{t("footer.privacy")}</Link></li>
              <li><Link to="/cookie" className="hover:text-white">{t("footer.cookie")}</Link></li>
              <li><Link to="/termini" className="hover:text-white">{t("footer.terms")}</Link></li>
              <li><Link to="/codice-etico" className="hover:text-white">{t("footer.ethics")}</Link></li>
            </ul>
          </div>
        </div>
        <div className="mt-10 pt-6 border-t border-white/10 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <p className="text-xs text-white/50">© {new Date().getFullYear()} CXOORA. {t("footer.rights")}</p>
          <div className="flex items-center gap-5 text-xs text-white/60">
            <span className="inline-flex items-center gap-1.5"><Mail size={14} /> contatti@cxoora.com</span>
            <span className="inline-flex items-center gap-1.5"><MapPin size={14} /> Milano, Italia</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
